var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value !== '' && _vm.value !== null)?_c('NcEditor',{attrs:{"can-edit":false,"text":_vm.value,"show-border":false,"show-readonly-bar":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }